import { ActionType, createAction } from 'typesafe-actions'

export enum ActionNames {
  TOGGLE_SIDEBAR_COLLAPSED_STATE = '[Sidebar] Toggle Sidebar Collapsed State',
}

export const toggleSidebarCollapsedState = createAction(ActionNames.TOGGLE_SIDEBAR_COLLAPSED_STATE)()

export type TSidebarActions = ActionType<typeof toggleSidebarCollapsedState>
